import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from '../shared/ClaimListing/ClaimListing';

export default function CallbackTab() {
  return (
    <ClaimListing
      columns={[
        ClaimColumns.assigned,
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.callbackType,
        ClaimColumns.assignedTo,
        ClaimColumns.callbackNotes,
      ]}
      filters={[ClaimFilters.insuredNameSearch]}
      additionalPayload={{ status: ClaimStatus.Callback }}
      includeExport={false}
    />
  );
}
